import React, { CSSProperties } from "react";
import FilmalityCircularProgress from "../../../shared/filmality-circular-progress";
import SceneSetting from "./scene-setting";
import Location from "./location";
import Errors from "../../../shared/errors";
import {
  OnboardingStep1ClassName,
  OnboardingStep2ClassName
} from "./ducks/reducer";

function Overview(props) {
  const {
    overview,
    locationsWithSubLocations,
    filmId,
    sceneSettingsAssignedPercentage,
    assignLocation,
    unassignLocation,
    replaceLocation,
    aliasSceneSetting,
    unaliasSceneSetting,
    errors
  } = props;

  const readOnly = overview.readOnly;

  return (
    <div>
      <div className="columns">
        <div className="circular-progress column is-one-quarter">
          <FilmalityCircularProgress
            percentage={sceneSettingsAssignedPercentage}
            title="Scene Settings Assigned"
          />
        </div>
      </div>
      {errors && <Errors errors={errors} />}
      <div className="columns">
        <div className="column">
          <table className={`${OnboardingStep1ClassName} table`}>
            <thead>
              <tr>
                <th>Scene Setting Name</th>
                <th>Scene Count</th>
                <th>Location Name</th>
              </tr>
            </thead>
            <tbody>
              {(overview.sceneSettings || []).map((sceneSetting, index) => {
                return (
                  <SceneSetting
                    key={index}
                    index={index}
                    sceneSetting={sceneSetting}
                    filmId={filmId}
                    assignLocation={assignLocation}
                    unassignLocation={unassignLocation}
                    replaceLocation={replaceLocation}
                    aliasSceneSetting={aliasSceneSetting}
                    unaliasSceneSetting={unaliasSceneSetting}
                    readOnly={readOnly}
                    canAccessShootingLocations={overview?.canAccessShootingLocations}></SceneSetting>
                );
              })}
            </tbody>
          </table>
        </div>
        {!readOnly && (
          <div className="column is-narrow">
            <table className={`${OnboardingStep2ClassName} table sticky`}>
              <thead>
                <tr>
                  <th>Location</th>
                </tr>
              </thead>
              <tbody>
                {(locationsWithSubLocations || []).map((location, index) => {
                  return (
                    <Location
                      key={index}
                      location={location}
                      index={index}
                      filmId={filmId}
                      readOnly={readOnly}
                      canAccessShootingLocations={overview?.canAccessShootingLocations}></Location>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default Overview;
